import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'mode-header-search',
  templateUrl: './header-search.component.html',
  styleUrls: ['./header-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderSearchComponent {
  @Input() display: 'bar' | 'button' = 'button';
  @Input() theme: 'light' | 'dark' = 'light';
}
